import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { isIOSAppUser, removeDefaultParams } from '../../../Utils/helper';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import { getSearchParams } from '../common';

export default function RecentArticleList(props) {
  const { data, index } = props;
  const [cardEffect, setCardEffect] = useState(' ');
  const router = useRouter();
  useEffect(() => {
    setCardEffect('');
  }, []);
  return (
    <Link
      href={{
        pathname:
          !isIOSAppUser() &&
          (data?.content?.content?.web_url || data?.content?.web_url),
        query: removeDefaultParams(router.query),
      }}
      passHref
      key={index}
      locale={false}
    >
      <li
        className={cardEffect}
        onClick={(e) => {
          e.preventDefault();
          setCardEffect('lowOpacity');
          setTimeout(() => {
            if (!isIOSAppUser())
              router.push(
                (data?.content?.content?.web_url || data?.content?.web_url) +
                  getSearchParams(),
                '',
                {
                  locale: getRouterLocale(router),
                },
              );
          }, [200]);
        }}
      >
        {data?.content?.content?.title || data?.content?.title}
      </li>
    </Link>
  );
}
